export var ArrowConfirm = {
  name: "arrow-confirm",
  component: "PossessionConfirm",
  layout: "possession-base",
  mode: "visible",
  showOn: true,
};
